import a from "./index851.js";
import f from "./index849.js";
var e = f(function(r, t) {
  return r == null ? {} : a(r, t);
});
export {
  e as default
};
